const truncateString = ({ string, length = 25 } = {}) => {
  if (string.length > length) return string.slice(0, length).concat('...');

  return string;
};

export default truncateString;
